import React from "react"
import styled from "styled-components"
import { Paragraph, Link, Li, Tag } from "buoy-core"
import { fontSize } from "buoy-theme"
import {
  AppIcon,
  CostIcon,
  HoursIcon,
  InsuranceIcon,
  PhoneIcon,
  LocationIcon,
} from "../../icons"
import ExpandableSection from "./ExpandableSection"
import { insuranceTooltip } from "../../../constants"
import Tooltip from "../../Tooltip"

const AddressLink = styled(Link)`
  ${fontSize("bodySmall")};
`

const ChecklistLi = styled(Li)`
  position: relative;
  padding-bottom: 6px;
  padding-left: 4px;
`

const Icon = styled.div`
  position: absolute;
  top: 5px;
  left: -21px;
`

const AvailableTag = styled(Tag)`
  margin-right: 10px;
  letter-spacing: 0.9px;
  -webkit-font-smoothing: antialiased;
  padding: 3px 15px;
  display: inline-block;

  background-color: ${props => (props.disabled ? "#d9d9d9" : "#C89CFF")};

  &:first-child {
    margin-left: 0;
  }
`

const TooltipContainer = styled.div`
  position: absolute;
  bottom: 2px;
  right: -22px;
`

const ParagraphText = styled.span`
  position: relative;
  margin-right: 22px;
`

const getTodayDay = () => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ]
  const d = new Date()
  return days[d.getDay()]
}

const getExpandableHeadline = info => {
  const closeTime = info[getTodayDay()].match(/(\d\s?p?a?m)/gm)[1]
  return `Open today until ${closeTime}`
}

const sanitizePhoneNumber = number => number.replace(/\D/gi, "")

const isDemo = () => window.location.pathname.startsWith("/demo")

const AvailableToSection = ({ availableTo }) => {
  const available = availableTo.map(aval => aval.available)

  return (
    <ChecklistLi>
      <Icon>
        <LocationIcon />
      </Icon>
      <Paragraph>Available To:</Paragraph>
      {available.includes("Non-union NYT employees") && (
        <AvailableTag>NY Times / Wirecutter</AvailableTag>
      )}
      {available.includes("Fake Love employees") && (
        <AvailableTag>Fake Love</AvailableTag>
      )}
      {available.includes("Non-union") && (
        <AvailableTag>Non-union</AvailableTag> // for demo dashboard
      )}
      {available.includes("All Plans") && (
        <AvailableTag>All Plans</AvailableTag> // for demo dashboard
      )}
    </ChecklistLi>
  )
}

export const InfoList = ({ infoList }) => {
  const finalList = []
  for (const info in infoList) {
    if (info === "time" && infoList.time) {
      finalList.push(
        <ChecklistLi key={info}>
          <Icon>
            <HoursIcon />
          </Icon>
          <Paragraph>{infoList[info]}</Paragraph>
        </ChecklistLi>
      )
    } else if (info === "hours" && !infoList.time) {
      finalList.push(
        <ExpandableSection
          key={info}
          title={getExpandableHeadline(infoList[info])}
          info={infoList[info]}
        />
      )
    } else if (info === "cost") {
      finalList.push(
        <ChecklistLi key={info}>
          <Icon>
            <CostIcon />
          </Icon>
          <Paragraph>{infoList[info]}</Paragraph>
        </ChecklistLi>
      )
    } else if (info === "insurance") {
      finalList.push(
        <ChecklistLi key={info}>
          <Icon>
            <InsuranceIcon />
          </Icon>
          <Paragraph>
            <ParagraphText>
              {infoList[info]}
              <TooltipContainer>
                <Tooltip message={insuranceTooltip} />
              </TooltipContainer>
            </ParagraphText>
          </Paragraph>
        </ChecklistLi>
      )
    } else if (info === "phone" && !isDemo() ) {
      finalList.push(
        <ChecklistLi key={info}>
          <Icon>
            <PhoneIcon />
          </Icon>
          <Link href={`tel:+1${sanitizePhoneNumber(infoList[info])}`}>
            {infoList[info]}
          </Link>
        </ChecklistLi>
      )
    } else if (info === "address" && !isDemo() ) {
      finalList.push(
        <ChecklistLi key={info}>
          <Paragraph>
            {`${infoList[info]} `}
            <AddressLink
              href={`https://maps.google.com/?q=${infoList[info]}`}
              target="_blank"
              rel="noopener"
            >
              see map
            </AddressLink>
          </Paragraph>
        </ChecklistLi>
      )
    } else if (info === "app") {
      finalList.push(
        <ChecklistLi key={info}>
          <Icon>
            <AppIcon />
          </Icon>
          <Paragraph>{infoList[info]}</Paragraph>
        </ChecklistLi>
      )
    } else if (info === "availableTo") {
      finalList.push(
        <AvailableToSection key={info} availableTo={infoList[info]} />
      )
    }
  }
  const sortingArr = ["time", "hours", "insurance", "phone", "address"]
  // sorts the content depending on the key and anything not on the sorting arr gets sent to the bottom
  return finalList.sort((a, b) => {
    // if the item is not on the sortingArr list the item gets sent to the bottom of the list
    if (sortingArr.indexOf(a.key.toLowerCase()) === -1) {
      return 1
    } else if (sortingArr.indexOf(b.key.toLowerCase()) === -1) {
      return -1
    } else {
      return (
        sortingArr.indexOf(a.key.toLowerCase()) -
        sortingArr.indexOf(b.key.toLowerCase())
      )
    }
  })
}



// WEBPACK FOOTER //
// ./assets/common/components/RecommendationCard/components/InfoList.js